<template>
  <div v-loading="isLoging">
    <el-dialog
      :title=title
      width="40%"
      top="2rem"
      :close-on-click-modal="false"
      :visible.sync="showDialog"
      :destroy-on-close="true"
      @close="close()"
    >
      <div style="margin-top: 1rem;margin-right: 100px;">
        <el-form ref="userFormRef" :rules="rules" :model="form" label-width="140px" >
          <el-form-item label="用户名" prop="username">
            <el-input :disabled="loginUserRole>1" v-model="form.username" clearable></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input :disabled="loginUserRole>1" type="password" v-model="form.password" clearable></el-input>
          </el-form-item>
          <el-form-item v-show="roleId == 3" label="上级用户" prop="upUserId">
            <el-select
                v-model="upUserId"
                :disabled="loginUserRole>1"
                style="width: 100%"
                placeholder="请选择所属二级管理员"
                @change="changeUpUser">
              <el-option value="0" label="请选择"></el-option>
              <el-option v-for="item in twoUserList" :key="item.id.toString()" :label="item.username" :value="item.id.toString()"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyId">
            <el-select
              v-model="companyId"
              :disabled="loginUserRole>1"
              style="width: 100%"
              placeholder="请选择公司"
              @change="changeCompany"
            >
              <el-option v-for="company in deptList" :key="company.companyId" :label="company.companyName" :value="company.companyId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职务名称" prop="roleId">
            <el-select
              v-model="roleId"
              :disabled="roleId == 1"
              style="width: 100%"
              placeholder="请选择职务"
              @change="changeRole"
            >
<!--              超级管理员不能添加。保证系统只有一个 -->
              <el-option v-if="loginUserRole <= 1 && roleId <=1 && isAdid" label="超级管理员" value="1"></el-option>
              <el-option v-if="loginUserRole <= 1" label="二级管理员" value="2"></el-option>
              <el-option label="子管理员" value="3"></el-option>
              <el-option label="一级用户" value="4"></el-option>
              <el-option label="二级用户" value="5"></el-option>
              <el-option label="三级用户" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" @click="onSubmit" :loading="dialogLoading" >保存</el-button>
              <el-button @click="close">取消</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/api/http.js'
import config from '@/utils/config.js'
import MediaServer from './../service/MediaServer'

export default {
  name: "userEdit",
  props: {},
  computed: {},
  created() {
    this.loginUserRole = JSON.parse(sessionStorage.getItem('userRole')).id
  },
  data() {
    return {
      title: '添加用户',
      isAdid:false,
      loginUserRole: '',
      upUserId: '',
      listChangeCallback: null,
      showDialog: false,
      isLoging: false,
      dialogLoading: false,
      platformList: [],
      mediaServer: new MediaServer(),
      form: {
        id: '',
        username: '',
        password: '',
        companyId: '',
        roleId: '',
      },
      companyId: '',
      roleId: '',
      deptList:{},
      twoUserList:[],
      rules: {
        username: [{ required: true, message: "请输入名称", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        companyId: [{ required: true, message: "请选择公司", trigger: "blur" }],
        upUserId: [{ required: true, message: "请选择上级用户", trigger: "blur" }],
        roleId: [{ required: true, message: "请输入角色权限等级", trigger: "blur" }]
      },
    };
  },
  methods: {
    openDialog: function (data, callback) {
      this.getdeptList()
      this.getTwoUserList()
      this.showDialog = true;
      this.title = '添加用户'
      // 默认值
      this.form.upUserId = this.upUserId = '0'
      this.listChangeCallback = callback;
      if (data != null) {
        this.isAdid = true;
        this.form.id = data.id;
        this.form.username = data.username;
        this.form.password = data.password;
        this.form.companyId = this.companyId = data.company.companyId
        this.form.upUserId = this.upUserId = data.upUserId
        this.form.roleId = this.roleId = data.role.id.toString()
        this.title = '编辑用户'
      }
    },
    getdeptList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/company/DropDownList` }).then( res => {
        that.deptList = res.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },
    getTwoUserList(){
      let that = this;
      this.$axios({ method: 'get', url:`/api/user/allTwoUser` }).then( res => {
        that.twoUserList = res.data.data;
      }).catch(function (error) {
        console.log(error);
      });
    },

    changeUpUser(val) {
      this.form.upUserId = val
    },
    changeCompany(val) {
      this.form.companyId = val
    },
    changeRole(val) {
      this.form.roleId = val
    },
    onSubmit: function () {
      this.dialogLoading = true;
      var that = this;
      this.$refs.userFormRef.validate(flag => {
        //表单验证通过
        if (flag) {
          if (that.form.id) {
            this.$axios({ method: 'post', url:`/api/user/edit`, params: {...this.form} }).then( res => {
              if (res.data.code == 0) {
                that.$message.success('修改成功')
                that.showDialog = false;
                if (that.listChangeCallback != null) {
                  that.listChangeCallback();
                  that.dialogLoading = false;
                  that.isAdid = false;
                }
              } else {
                that.$message.error(res.data.msg)
              }
            }).catch(error => {
              this.dialogLoading = false;
              this.isAdid = false;
            });
          } else {
            this.$axios({ method: 'post', url:`/api/user/add`, params: {...this.form} }).then( res => {
              if (res.data.code == 0) {
                that.$message.success('添加成功')
                that.showDialog = false;
                that.isAdid = false;
                if (that.listChangeCallback != null) {
                  that.listChangeCallback();
                }
              } else {
                that.$message.error(res.data.msg)
              }
              that.dialogLoading = false;
              that.isAdid = false;
            }).catch(error => {
              this.dialogLoading = false;
              this.isAdid = false;
            });
          }
        } else {
          that.dialogLoading = false;
          that.isAdid = false;
          return this.$message.error('请按照格式要求输入数据')
        }
      })
    },
    close() {
      this.form = {
        id: '',
        username: '',
        password: '',
        companyName: '',
        companyId: '',
        upUserId:'',
        roleId: '',
      }
      this.companyId = ''
      this.upUserId = ''
      this.roleId = ''
      // this.$refs.userFormRef.resetFields()
      this.showDialog = false;
      this.dialogLoading = false;
      this.isAdid = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/dialog/userEdit.vue